import { type ObjectValuesUnionType } from '../../../utils/typing';

export const KLUserStatuses = Object.freeze({
  IN: 'IN', // Register in an adventure
  OUT: 'OUT', // Eliminated from adventure
  OFF: 'OFF', // Not registered to an adventure,
  EXCLUDED: 'EXCLUDED', // Excluded from the adventure
});
export type KLUserStatus = ObjectValuesUnionType<typeof KLUserStatuses>;
